import axios from "axios";
import { CONST } from "../config/const";

// ファイルアップロード用署名付きURL取得（画像）
export async function getPresignedPostPicture(
  display: string,
  nowTimeName: string,
  fileName: string
) {
  try {
    const path = "presigned_post/picture";
    const params = { display, nowTimeName, fileName };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    const presigned_object = response.data.presigned_object as {
      fields: { [key: string]: string };
      url: string;
    };
    const destination_key = response.data.destination_key as string;
    return { presigned_object, destination_key };
  } catch (error) {
    // logout();
    return { presigned_object: { fields: {}, url: "" }, destination_key: "" };
  }
}

// 署名付きURLでファイルアップロード
export async function postPresignedPost(url: string, formData: FormData) {
  try {
    await fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        accept: "multipart/form-data",
      },
    });
    return "seccess";
  } catch (error) {
    // logout();
    return "failed";
  }
}
